import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { queryClient } from 'src/queryClient'

const useClearCacheOnUnmount = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: [pathname], exact: false })
    }
  }, [pathname, queryClient])
}

export default useClearCacheOnUnmount